import * as XLSX from 'xlsx';

const sanitizeSheetName = (name) =>
  String(name || 'Sheet')
    .replace(/[\\/?*[\]:]/g, '_')
    .slice(0, 31);

const formatDisplayDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    return new Date(`${dateStr}T12:00:00`).toLocaleDateString('en-IN', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
};

/**
 * Export roll-call workbook for one activity on a date.
 * One worksheet per time slot; includes blank "Attended" column for manual marking.
 */
export const exportActivityRollCallExcel = ({ activityName, date, slots }) => {
  if (!slots?.length) return;

  const wb = XLSX.utils.book_new();
  const displayDate = formatDisplayDate(date);
  const safeActivity = String(activityName || 'activity').replace(/\s+/g, '_');

  slots.forEach((slot, index) => {
    const timeLabel = `${slot.startTime || ''}-${slot.endTime || ''}`.replace(/:/g, '');
    const instructors = (slot.instructorNames || [])
      .filter(Boolean)
      .join(', ') || slot.instructorName || '—';
    const guests = slot.enrolledGuests || [];

    const rows = [
      ['Activity Roll Call'],
      ['Activity', activityName || '—'],
      ['Date', displayDate],
      ['Time', `${slot.startTime || '—'} – ${slot.endTime || '—'}`],
      ['Instructor', instructors],
      ['Room', slot.roomName || '—'],
      ['Enrolled', guests.length],
      ['Capacity', slot.maxCapacity ?? '—'],
      [],
      ['#', 'Guest Name', 'Guest ID', 'Source', 'Attended'],
    ];

    if (guests.length === 0) {
      rows.push(['', 'No enrollments', '', '', '']);
    } else {
      guests.forEach((guest, i) => {
        const attendedLabel =
          guest.attended === true ? 'Y' : guest.attended === false ? 'N' : '';
        const sourceLabel = guest.enrollmentSource === 'walk_in' ? 'Walk-in' : 'Enrolled';
        rows.push([
          i + 1,
          guest.guestName || '—',
          guest.guestId || '—',
          sourceLabel,
          attendedLabel,
        ]);
      });
    }

    const ws = XLSX.utils.aoa_to_sheet(rows);
    ws['!cols'] = [{ wch: 4 }, { wch: 28 }, { wch: 14 }, { wch: 12 }, { wch: 12 }];

    const sheetName = sanitizeSheetName(
      slots.length > 1 ? `${timeLabel || `slot_${index + 1}`}` : activityName || 'Roll Call'
    );
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
  });

  const filename = `roll_call_${safeActivity}_${date}.xlsx`;
  XLSX.writeFile(wb, filename);
};
